import React, { FC, PropsWithChildren, createContext, memo, useContext, useState } from 'react';
import ReactMapboxGl from 'react-mapbox-gl';
import type { Map as MapboxMap } from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

const mapboxAccessToken = 'pk.eyJ1Ijoid2VzdG5vdm8iLCJhIjoiY201YWJ6ZGZvNG1sYTJqcTNicnQ5OTd4aSJ9.KmYWo2qZ1PLeOO55tyhiIg';

const MapInstanceContext = createContext<MapboxMap | null>(null);
export const useMapInstance = () => useContext(MapInstanceContext);

const DEFAULT_CENTER: [number, number] = [0, 0];
const DEFAULT_ZOOM: [number] = [16];

const Mapbox = ReactMapboxGl({
  accessToken: mapboxAccessToken,
});

const Index: FC<PropsWithChildren> = ({ children }) => {
  const [mapInstance, setMapInstance] = useState<MapboxMap | null>(null);

  if (!mapboxAccessToken) {
    console.warn('Mapbox access token is missing. Set MAPBOX_ACCESS_TOKEN or REACT_APP_MAPBOX_ACCESS_TOKEN.');
    return <div className='p-4 text-sm text-red-500'>Mapbox access token is required to load the map.</div>;
  }

  return (
    <div className='flex h-full'>
      <div className='flex-1 relative'>
        <MapInstanceContext.Provider value={mapInstance}>
          <Mapbox
            style='mapbox://styles/mapbox/streets-v9'
            containerStyle={{ height: '100%', width: '100%' }}
            center={DEFAULT_CENTER}
            zoom={DEFAULT_ZOOM}
            onStyleLoad={(map) => setMapInstance(map)}
          >
            {mapInstance && children}
          </Mapbox>
        </MapInstanceContext.Provider>
      </div>
    </div>
  );
};

export default memo(Index);
